var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKg = function SvgKg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4bb53ed1-7845-4014-a440-be9c8ddae1d1a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3871285d-d123-4e36-a589-2069444b01b9b",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#3871285d-d123-4e36-a589-2069444b01b9b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB0624",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF100",
    fillRule: "evenodd",
    d: "M10.206 9.485a3 3 0 0 0 .588 0L10.5 8.75zM8.85 8.94C8.327 8.526 8 7.922 8 7.25c0-.793.456-1.49 1.144-1.89L10 7.5zm3.006-3.58C12.544 5.76 13 6.457 13 7.25c0 .673-.328 1.277-.85 1.69L11 7.5zm-.1-.056A2.7 2.7 0 0 0 10.5 5c-.458 0-.887.11-1.256.304l1.256 1.57z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF100",
    fillRule: "evenodd",
    d: "M10.5 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4bb53ed1-7845-4014-a440-be9c8ddae1d1a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgKg;